export default __webpack_public_path__ + "static/media/partners-img.52a7b5fc.svg";